<mat-spinner [diameter]="64" mode="indeterminate" style="margin: 1em"></mat-spinner>
